import { css } from 'styled-components';

export const LocationWithBalanceStyled = css`
.location-with-balance {
    .ant-select-item-option-content {
      display: flex;

      .text {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .name {
          font-weight: 400;
        }
      }

      .balance {
        margin-left: 4px;
        text-align: right;
      }
    }

    &.small .ant-select-item-option-content {
      min-width: 200px;
      max-width: 200px;
    }
  }
`;
